import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

import MatterTasks from "@/components/features/matter/tasks/MatterTasks";
import { AppModal } from "@/components/ui";
import type { Matter, MatterSubItemType } from "@/lib/types";

interface MatterSubItemTasksModalProps {
  entityLabel: string;
  title?: string;
  subtitle?: string;
  matter: Matter;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  subItem: {
    id: string;
    type: MatterSubItemType;
  };
}

export const MatterSubItemTasksModal = ({
  entityLabel,
  title,
  subtitle,
  matter,
  onOpenChange,
  open,
  subItem,
}: MatterSubItemTasksModalProps) => {
  const router = useRouter();
  useEffect(() => {
    if (!open) return;
    return router.subscribe("onBeforeNavigate", () => {
      onOpenChange(false);
    });
  }, [router, open, onOpenChange]);

  return (
    <AppModal
      open={open}
      onOpenChange={onOpenChange}
      title={
        title ??
        `${subItem.type === "phase-action" ? "Task" : "Tasks"} for ${entityLabel}`
      }
      size="3xl"
      bodyContained
    >
      <div className="flex h-[min(70vh,42rem)] min-h-0 flex-col">
        {subtitle ? (
          <p className="px-6 py-3 text-sm font-medium">{subtitle}</p>
        ) : null}
        <MatterTasks
          tasks={[]}
          matter={matter}
          subItem={subItem}
          defaultVariant="list"
          showCreateButton={subItem.type !== "phase-action"}
          showFilters={false}
          bareLayout
          loadMoreMode="infinite"
        />
      </div>
    </AppModal>
  );
};
